// TODO this file needs some proper refactoring....
import concat from 'lodash/concat';
import get from 'lodash/get';
import toPath from 'lodash/toPath';
import isPlainObject from 'lodash/isPlainObject';
import isArray from 'lodash/isArray';
import concatPath from '@converdy/utils/concat-path';
import debounce from 'lodash/debounce';

import overwriteDeep from '@converdy/utils/overwrite-deep';

export default {
  inject: ['Control'],

  props: {
    path: {type: [String, Array]},
    responsive: {type: Boolean},
    default: {type: null},
    label: {},
    errorText: String,
  },

  methods: {
    concat,

    nest(path) {
      return concat(toPath(this.path), toPath(path));
    },

    getValue(path) {
      return get(this.value, path);
    },

    dirty(property) {
      /*
       * if there was no path provided assume base value to
       * be the same as the entire propertise object
       */
      const controlValue = this.path
        ? get(this.Control.properties, this.path)
        : this.Control.properties;

      /*
       * allow checking dirty for either the entire value or
       * arguably more commonly for one of its nested properties
       */
      let value = property ? get(controlValue, property) : controlValue;

      if (this.responsive) {
        value = value && value[this.Control.breakpoint];
      }

      if (isPlainObject(value)) {
        return Object.keys(value).length > 0;
      }

      if (isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'boolean') {
        return true;
      }

      return Boolean(value);
    },

    getResponsiveEmission(nonResponsiveEmission) {
      const {propName} = nonResponsiveEmission;

      const currentValue = propName
        ? get(this.nonDefaultedValue, propName)
        : this.nonDefaultedValue;

      const value = overwriteDeep(currentValue || {}, {
        [this.Control.breakpoint]: nonResponsiveEmission.value,
      });

      return {propName, value};
    },

    getEmission(path, value) {
      let emission;

      if (this.responsive) {
        emission = this.getResponsiveEmission({propName: path, value});
      } else {
        emission = {propName: path, value};
      }

      if (!this.path) return emission;

      let propName = path
        ? concat(toPath(this.path), toPath(path))
        : toPath(this.path);
      /*
       lodash get and set works with both arrays and . divided paths, however a combination of the two doesn't work
      there for we normalize to full dot notation first */
      propName = Array.isArray(propName) ? propName.join('.') : propName;
      return {...emission, propName};
    },

    handleChange(path, value) {
      this.Control.handleInput(this.getEmission(path, value));
      this.$emit('input', value);
      this.debouncedChange(path, value);
    },
    debouncedChange: debounce(function (path, value) {
      this.Control.handleChange(this.getEmission(path, value));
      this.$emit('change', value);
    }, 350),
    handleInput(path, value) {
      this.Control.handleInput(this.getEmission(path, value));
      this.$emit('input', value);
    },

    handleUiChange(path, value) {
      this.Control.handleUiChange(this.getEmission(path, value));
    },

    handleReset(path) {
      // if not resettable return
      if (!this.Control.resettable) {
        return;
      }

      let computedPath = this.path;

      if (path) {
        computedPath = concat(computedPath, path);
      }

      if (this.responsive) {
        computedPath = concat(computedPath, this.Control.breakpoint);
      }

      computedPath = toPath(computedPath);

      this.Control.handleReset({propName: computedPath});

      this.$emit('reset');
    },
  },

  computed: {
    nonDefaultedValue() {
      return this.path
        ? get(this.Control.properties, this.path)
        : this.Control.properties;
    },

    rawValue() {
      const value = this.path
        ? get(this.Control.computedProperties, this.path)
        : this.Control.computedProperties;

      /* fix for when we change a control to responsive but the value hasn't been updated yet */
      if (this.responsive) {
        return typeof value === 'string' || typeof value === 'undefined'
          ? this.default || {}
          : value;
      }

      return value || this.default;
    },

    value() {
      if (this.responsive) {
        const v = this.rawValue[this.Control.breakpoint];

        if (typeof v === 'undefined') {
          if (this.Control.breakpoint === 'mobile') {
            return typeof this.rawValue.tablet !== 'undefined'
              ? this.rawValue.tablet
              : this.rawValue.desktop;
          } else {
            return this.rawValue.desktop;
          }
        }

        return v;
      } else {
        return this.rawValue;
      }
    },

    ui() {
      return (
        (this.path ? get(this.Control.ui, this.path) : this.Control.ui) || {}
      );
    },
  },
};
